import * as actionTypes from "../actions/actionTypes";

const initialState = {
  fxhead: null,
};

export default (state = initialState, action = {}) => {
  switch (action.type) {

    case actionTypes.SAVE_FX_HEAD:
      return {
        ...state,
        fxhead: action.fx,
      };

    default:
      return state;
  }


};